
export class Generic {
  public _id: string
  public type: string
  public name: string

  constructor(name, type?) {
    this._id = ''
    this.name = name
    if (type)
      this.type = type
  }
}
